import { Typography } from '@/components/atoms';
import { ListingEmptyBuildingsIcon } from '@/modules/properties-web/components/ListingEmptyBuildingsIcon';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export interface GuestListEmptyStateProps {
  readonly title: string;
  readonly subtitle?: string;
}

/**
 * Guest list empty / error panel.
 * Reuses properties-web empty illustration for consistent listing cases.
 */
export function GuestListEmptyState({
  title,
  subtitle,
}: Readonly<GuestListEmptyStateProps>) {
  return (
    <View style={styles.container}>
      <ListingEmptyBuildingsIcon />
      <View style={styles.copy}>
        <Typography
          variant="title2"
          color="highContrast"
          style={styles.title}
        >
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="body" color="secondary" style={styles.subtitle}>
            {subtitle}
          </Typography>
        ) : null}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 64,
    paddingHorizontal: 24,
    gap: 24,
  },
  copy: {
    alignItems: 'center',
    gap: 8,
    width: '100%',
    maxWidth: 420,
  },
  title: {
    width: '100%',
    textAlign: 'center',
  },
  subtitle: {
    width: '100%',
    textAlign: 'center',
  },
});
